import Vue from 'vue'
import App from '@/core/app'

Vue.config.productionTip = false

new Vue(App).$mount('#app')
